import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'gwx-voyager-components';
import classnames from 'classnames';

/**
 * Returns whether the provided email is semantically valid.
 *
 * @param {String} email
 */
function validateEmail(email) {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

class AddressInput extends Component {
	constructor(props) {
		super(props);
		this.showAddressInput = this.showAddressInput.bind(this);
		this.hideAddressInput = this.hideAddressInput.bind(this);
		this.cancelSubmit = this.cancelSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleAddAddress = this.handleAddAddress.bind(this);
		this.handleError = this.handleError.bind(this);
		this.state = {
			addressInputVisible: false,
			valueIsError: false,
			isSubmitting: false,
			errorMessage: null
		};
	}

	showAddressInput() {
		this.setState({ addressInputVisible: true });
	}

	hideAddressInput() {
		this.setState({
			addressValue: '', valueIsError: false, isSubmitting: false, addressInputVisible: false, errorMessage: null
		});
	}

	cancelSubmit() {
		this.setState({
			isSubmitting: false
		});
	}

	handleChange(event) {
		this.setState({
			addressValue: event.target.value,
			valueIsError: false,
			isSubmitting: false,
			errorMessage: null
		});
	}

	handleKeyDown(event) {
		const { key } = event;
		if (key === 'Enter') {
			this.handleAddAddress();
		}
	}

	handleError(errorMessage) {
		this.setState({
			valueIsError: true,
			isSubmitting: false,
			errorMessage
		});
	}

	handleAddAddress() {
		if (this.state.addressValue && validateEmail(this.state.addressValue.trim())) {
			this.setState({ isSubmitting: true });
			this.props.addAddress(this.state.addressValue.trim(), this.hideAddressInput, this.handleError, this.cancelSubmit);
			return;
		}
		this.handleError('Invalid email address.');
	}

	render() {
		return this.state.addressInputVisible ? (
			<div>
				<div className={classnames('input-group add-address-group', {'is-invalid' : this.state.valueIsError})}>
					<input
						type='text'
						name={`${this.props.id}-address`}
						className={classnames({ 'is-invalid': this.state.valueIsError }, 'form-control form-control-sm')}
						value={this.state.addressValue || ''}
						onKeyDown={this.handleKeyDown}
						onChange={this.handleChange}
						disabled={this.state.isSubmitting}
					/>
					<div className='input-group-btn'>
						<button
							type='button'
							id={`${this.props.id}-add`}
							className={classnames('btn btn-sm btn-success', { 'btn-danger': this.state.valueIsError }, { 'btn-warning': this.state.isSubmitting })}
							onClick={this.handleAddAddress}
							title='Add Address'
							disabled={this.state.isSubmitting}
						>
							<Icon iconName={this.state.isSubmitting ? 'spinner fa-spin' : 'user-plus'} />
						</button>
					</div>
					<div className='input-group-btn'>
						<button
							type='button'
							id={`${this.props.id}-cancel`}
							className={classnames('btn btn-sm btn-default', { 'btn-danger': this.state.valueIsError })}
							onClick={this.hideAddressInput}
							title='Cancel'
							disabled={this.state.isSubmitting}
						>
							<Icon iconName='close' />
						</button>
					</div>
				</div>
				<span id={`${this.props.id}-helpBlock`} className={classnames({ 'invalid-feedback': this.state.valueIsError })}>{this.state.errorMessage}</span>
			</div>
		) : (
			<button type='button' className='btn btn-sm btn-link btn-table-link add-address-link' onClick={this.showAddressInput}>
				+ Add Address
			</button>
		);
	}
}

AddressInput.propTypes = {
	/**
	 * Whether opportunity data is being fetched
	 */
	id: PropTypes.string.isRequired,
	/**
	* Function that adds the address
	*/
	addAddress: PropTypes.func.isRequired
};

export default AddressInput;
